export enum AuditModule {
  HumanResources = 'HumanResources',
  ECDD = 'ECDD',
  Transaction = 'Transaction',
  Finance = 'Finance',
  Configuration = 'Configuration',
  DCDD = 'DCDD',
}

export enum AuditAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  UPLOAD = 'UPLOAD',
  PAY = 'PAY',
  REVERSE = 'REVERSE',
  SENDMAIL = 'SENDMAIL',
}

export enum RecordTypesConfig {
  //UserAccountEntity = 'UserAccountEntity',
  UserEntity = 'UserEntity',
  RoleEntity = 'RoleEntity',
  PermissionEntity = 'PermissionEntity',
  LookupEntity = 'LookupEntity',
  BankEntity = 'BankEntity',
  //CategoryEntity = 'CategoryEntity',
  ContactCategoryEntity = 'ContactCategoryEntity',
  CountryEntity = 'CountryEntity',
  CurrencyEntity = 'CurrencyEntity',
  //DepartmentEntity = 'DepartmentEntity',
  DialectEntity = 'DialectEntity',
  DisciplineEntity = 'DisciplineEntity',
  GSTRateEntity = 'GSTRateEntity',
  IDTypeEntity = 'IDTypeEntity',
  //InformationTypeEntity = 'InformationTypeEntity',
  //MaritalEntity = 'MaritalEntity',
  NationalityEntity = 'NationalityEntity',
  QualificationEntity = 'QualificationEntity',
  SchemeTypeEntity = 'SchemeTypeEntity',
  CommMatrixTypeEntity = 'CommMatrixTypeEntity',
  TransactionTypeEntity = 'TransactionTypeEntity',
}

export enum RecordTypesTransaction {
  ProjectEntity = 'ProjectEntity',
  BusinessDirectorEntity = 'BusinessDirectorEntity',
  UnitEntity = 'UnitEntity',
  KeyAppointmentEntity = 'KeyAppointmentEntity',
  TeamEntity = 'TeamEntity',
  TeamMemberEntity = 'TeamMemberEntity',
  ProjectCommissionEntity = 'ProjectCommissionEntity',
  ReferralEntity = 'ReferralEntity',
  ManagementCommEntity = 'ManagementCommEntity',
  PDOverrideEntity = 'PDOverrideEntity',
  PDReferralEntity = 'PDReferralEntity',
  PDManagementEntity = 'PDManagementEntity',
  AppointmentTypeEntity = 'AppointmentTypeEntity',
  DisOverridingEntity = 'DisOverridingEntity',
  DisBonusEntity = 'DisBonusEntity',
  CommSchemeEntity = 'CommSchemeEntity',
  TransactionEntity = 'TransactionEntity',
  TransactionBuyerEntity = 'TransactionBuyerEntity',
  BlankFormEntity = 'BlankFormEntity',
  BlankFormBuyerEntity = 'BlankFormBuyerEntity',
  BatchEntity = 'BatchEntity',
  BatchBlankFormEntity = 'BatchBlankFormEntity',
  BatchProformaEntity = 'BatchProformaEntity',
  ResaleEntity = 'ResaleEntity',
  ResaleAdjustmentEntity = 'ResaleAdjustmentEntity',
  NoReminderEntity = 'NoReminderEntity',
}

export enum RecordTypesFinance {
  // LedgerAccountEntity = 'LedgerAccountEntity',
  LedgerAccountMasterEntity = 'LedgerAccountMasterEntity',
  LedgerAccountLocalEntity = 'LedgerAccountLocalEntity',
  AccountSettingEntity = 'AccountSettingEntity',
  JournalEntity = 'JournalEntity',
  AccountPeriodEntity = 'AccountPeriodEntity',
  ContactEntity = 'ContactEntity',
  ContactAddressEntity = 'ContactAddressEntity',
  ContactPersonEntity = 'ContactPersonEntity',
  ContactBankEntity = 'ContactBankEntity',
  // TaxInvoiceEntity = 'TaxInvoiceEntity',
  CustomerInvoiceEntity = 'CustomerInvoiceEntity',
  CreditNoteEntity = 'CreditNoteEntity',
  DebitNoteEntity = 'DebitNoteEntity',
  SupplierInvoiceEntity = 'SupplierInvoiceEntity',
  SupplierCreditNoteEntity = 'SupplierCreditNoteEntity',
  ReceiptEntity = 'ReceiptEntity',
  BankAccountEntity = 'BankAccountEntity',
  ChequeBooksEntity = 'ChequeBooksEntity',
  PaymentEntity = 'PaymentEntity',
  ReversalPaymentEntity = 'ReversalPaymentEntity',
  ReversalReceiptEntity = 'ReversalReceiptEntity',
  PaymentGeneratorEntity = 'PaymentGeneratorEntity',
  PaymentDirectEntity = 'PaymentDirectEntity',
  ProfitCenterEntity = 'ProfitCenterEntity',
  StatementOfAccountEntity = 'StatementOfAccountEntity',
  ReceiptModeEntity = 'ReceiptModeEntity',
  PaymentReminderEntity = 'PaymentReminderEntity',
  PaymentReminderInfoEntity = 'PaymentReminderInfoEntity'

}

export enum RecordTypesHrm {
  SalespersonEntity = 'SalespersonEntity',
  CareerProgressionEntity = 'CareerProgressionEntity',
  DocumentEntity = 'DocumentEntity',
  EmplacementEntity = 'EmplacementEntity',
  HistoryEntity = 'HistoryEntity',
  EducationEntity = 'EducationEntity',
  AdditionalEntity = 'AdditionalEntity',
  CommissionSchemeEntity = 'CommissionSchemeEntity',
  ProfitSharingEntity = 'ProfitSharingEntity',
  SalespersonVerifyEntity = 'SalespersonVerifyEntity',
  GCEEntity = 'GCEEntity',
  IR8AEntity = 'IR8AEntity',
  LeadershipDesignationEntity = 'LeadershipDesignationEntity',

}

export enum RecordTypesECDD {
  ECDDEntity = 'ECDDEntity',
}